import axios from "axios";

function ApiRequest(fullURL = false, appNameHeader = true) {
  const axiosInstance = axios.create({
    baseURL: !fullURL ? import.meta.env.VITE_API_BASE_URL : undefined,
    withCredentials: true,
  });
  if (appNameHeader) {
    axiosInstance.defaults.headers.common["Content-Type"] = "application/json";
    axiosInstance.defaults.headers.common["x-app-name"] =
      import.meta.env.VITE_APP_NAME;
  }
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (err) => {
      if (err.response?.status !== 401) {
        return Promise.reject(err);
      }
      return Promise.reject(err);
    },
  );
  return axiosInstance;
}

export default ApiRequest;
